/**
 * Path to a legacy Invoice's "no longer available" page. The Project is
 * optional because an old bookmark cannot supply one — without it the page
 * still explains itself, it just cannot link on to the Project's files.
 */
export const legacyInvoicePath = (
  invoiceId: number,
  projectPublicId?: string
): string =>
  projectPublicId
    ? `/invoices/${invoiceId}?projectId=${projectPublicId}`
    : `/invoices/${invoiceId}`;
